import { ClientsService, SocketService } from "services";
import { DefaultStrategy, FeedStrategy, SystemStrategy } from "./implementation";
import { EventHandlingStrategy } from "./implementation/abstract.strategy";
type IMaybeEventName = string | null;

export class HandlingStrategyFactory {
  private strategies: Map<[IMaybeEventName, IMaybeEventName][], EventHandlingStrategy>;

  constructor(
    private readonly clientsService: ClientsService,
    private readonly socketService: SocketService,
  ) {
    this.strategies = new Map();
    this.strategies.set(DefaultStrategy.getEvents(), new DefaultStrategy(this.clientsService, this.socketService));
    this.strategies.set(SystemStrategy.getEvents(), new SystemStrategy(this.clientsService, this.socketService));
    this.strategies.set(FeedStrategy.getEvents(), new FeedStrategy(this.clientsService, this.socketService));
  }

  public getStrategyByClientName(eventName: string): EventHandlingStrategy {
    for (const strategy of this.strategies) {
      if (strategy[0].some(([clientEvent]) => clientEvent === eventName)) {
        return strategy[1];
      }
    }

    throw new Error(`Strategy for event ${eventName} not found`);
  }

  public getStrategiesByServerName(eventName: string): EventHandlingStrategy[] {
    const strategies = [];

    for (const [events, strategy] of this.strategies) {
      if (events.some(([, serverEvent]) => serverEvent === eventName)) {
        strategies.push(strategy);
      }
    }

    if (strategies.length === 0) {
      throw new Error(`Strategies for event ${eventName} not found`);
    } else {
      return strategies;
    }
  }

  private getStrategyOfType<T extends EventHandlingStrategy>(strategyType: new (...args: any[]) => T): T {
    for (const [, strategy] of this.strategies) {
      if (strategy instanceof strategyType) {
        return strategy;
      }
    }

    throw new Error(`${strategyType.name} not found`);
  }

  public getSystemStrategy(): SystemStrategy {
    return this.getStrategyOfType(SystemStrategy);
  }

  public getFeedStrategy(): FeedStrategy {
    return this.getStrategyOfType(FeedStrategy);
  }
}
